import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export default {
  state: {
    item: null,
    client: null,
    avaliableSchedule: [],
    loadingCheckout: false,
    timeChoosen: null,
    dateChoosen: null,
    hotSiteToken: null,
    unityChoosen: null,
    acceptance: false,
    loadingOrderRequest: false,
    itemChoosen: '',
    paymentChoosen: '',
    cart: {
      user: {
        id: ''
      },
      item: [
        {
          id: '',
          count: 1,
          questions: {}
        }
      ]
    }
  },
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/Checkout/index.js